import { WithApolloContext } from 'modules/Apollo/types';
import { useStudies } from '../domains/viewer/Viewer/StudyLoader/useStudies';

const useStudyIds = ({ context }: WithApolloContext): ReadonlyArray<string> => {
  const { priorStudiesIds } = useStudies({ context });
  return priorStudiesIds;
};

export default useStudyIds;
